// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import { ModalHeader } from "metabase/common/components/ModalContent";

export const EmbedModalHeader = styled(ModalHeader)`
  padding: 1.5rem 2rem;
  color: var(--mb-color-text-secondary);
  border-bottom: 1px solid var(--mb-color-border-neutral);
`;
